// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/Chat.scss
// module id = ./src/styles/Chat.scss
// module chunks = 0